<template>
  <div>
  <ShipBulk v-if="ship.type === 'tanker' || ship.type === 'bulk carrier'" v-bind:ship="ship" :rotors="rotors" view="profile" @toggleRotor="onToggleRotor" :scale="scale"/>
  <ShipRoPax v-if="ship.type === 'ro-ro'" v-bind:ship="ship" :rotors="rotors" view="profile" @toggleRotor="onToggleRotor" :scale="scale"/>
  <ShipPax v-if="ship.type === 'pax'" v-bind:ship="ship" :rotors="rotors" view="profile" @toggleRotor="onToggleRotor" :scale="scale"/>
  </div>
</template>

<script>
import ShipBulk from "./ShipBulk.vue";
import ShipRoRo from "./ShipRoRo.vue";
import ShipRoPax from "./ShipRoPax.vue";
import ShipPax from "./ShipPax.vue"

export default {
  name: "ShipView",
  components: {
    ShipBulk,
    ShipRoRo,
    ShipRoPax,
    ShipPax
  },
  props: {
    ship: Object,
    view: String,
    rotors: Object,
    rotorsEditable: {
      type: Boolean,
      default: true,
    },
    scale: {
      type: Number,
      default: 1.0
    }
  },
  methods: {
    onToggleRotor(rotorPosition) {
      if (this.rotorsEditable) {
        this.rotors.placement[rotorPosition[0]].splice(rotorPosition[1],1,!this.rotors.placement[rotorPosition[0]][rotorPosition[1]])
        this.$emit("onRotorChange")
      }
    }
  }
};
</script>
